export { default } from "./routes/media/favorites_article/$favArticleId.tsx";